import { api } from './../../api.js';

import axios from 'axios';

const state = {
  // organizations: [],
  // current_organization:''

}

const getters = {
  // getOrganizations: (state) => {
  //   return state.organizations
  // },
  // getCurrentOrganization: (state) => {
  //   return state.current_organization
  // }

}

const mutations = {
  // setUserOrganizations: (state, org) => {
  //   state.organizations = org;
  //   console.log(state.organizations);
  // },
  // setUserCurrentOrganization: (state, org) => {
  //   state.current_organization = org;
  //   console.log(state.organizations);
  // },
};

const actions = {
  getOrganizations: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      var params = {
        filters: data.filters
      };

      api
        .get("admin/organizations", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getOrganization: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/" + data.id, {})
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  createOrganization: function({ commit }, data) {
    data.dob = "1970/05/05";
    return new Promise((resolve, reject) => {
      api
        .post("admin/organizations", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  editOrganization: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch("admin/organizations/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  deleteOrganization: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete("admin/organizations/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getOrganizationPartners: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/integrations/partners", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getOrganizationIntegrationSettings: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/"  +  data.id  +  "/integration-settings/"+ data.integration_id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  UpdateOrganizationIntegrationSettings: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/organizations/" + data.id + "/integration-settings/" + data.integration_id, data.filters)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  addProviderToOrganization: function({ commit }, data) {
    console.log(data);
    
    if(data.create && data.create == true) {
      console.log("ADD PROVIDER");
      return new Promise((resolve, reject) => {
        api
          .post(
            "admin/organizations/" + data.organization_id + "/add-provider",
            data
          )
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  changeProviderStatus: function({commit}, data){
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/organizations/" + data.organization_id + "/change-provider-status/" + data.provider_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    })
  },
  changeStatusBulk: function({commit}, data){
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/bulk/organizations/providers/change-status/" ,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    })
  },
  getOrganizationProviders: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/" + data.id + "/providers", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getOrganizationCourses: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/" + data.id + "/courses", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  deleteProviderFromOrganization: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete(
          "admin/organizations/" +
            data.organization_id +
            "/delete-provider/" +
            data.provider_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  deleteProviderFromOrganization1: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete("admin/organizations/providers/" + data.provider_id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  deleteCourseFromOrganization: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete(
          "admin/organizations/" + data.id + "/delete-course/" + data.course_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getOrganizationImports: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/" + data.id + "/imports", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getOrganizationImportLogs: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "admin/organizations/" + data.id + "/imports/" + data.import_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getOrganizationImport: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "admin/organizations/" + data.id + "/imports/" + data.import_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  editOrganizationImportColumnMapping: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/organizations/" +
            data.id +
            "/imports/" +
            data.import_id +
            "/columns",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  generateOrganizationImportPreview: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/organizations/" +
            data.id +
            "/imports/" +
            data.import_id +
            "/preview",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getOrganizationImportPreview: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "admin/organizations/" +
            data.id +
            "/imports/" +
            data.import_id +
            "/preview",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getOrganizationImportRawPreview: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "admin/organizations/" +
            data.id +
            "/imports/" +
            data.import_id +
            "/raw",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getImportFormats: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/formats", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  processOrganizationImportPreview: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/organizations/" +
            data.id +
            "/imports/" +
            data.import_id +
            "/process",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  shiftBlockingDisabled: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/organizations/" +
            data.id +
            "/providers/" +
            data.provider_id +
            "/shift_blocking/disable",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  editOrganizationImportLog: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch(
          "admin/organizations/" +
            data.id +
            "/imports/" +
            data.import_id +
            "/row/" +
            data.row_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getOrganizationProviderInfo: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "admin/organizations/" + data.id + "/provider/" + data.provider_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getOrganizationHours: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/hours", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getOrganizationSubroles: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/" + data.id + "/roles/users", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getOrganizationRoles: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/" + data.id + "/roles", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  createOrganizationSubrol: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/organizations/" + data.id + "/roles/add-user", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  editOrganizationSubrole: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch(
          "admin/organizations/" + data.id + "/roles/edit-user/" + data.user_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  changeUserStatus: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/organizations/" + data.organization_id + "/roles/" + data.status + "/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  deleteOrganizationSubrole: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete(
          "admin/organizations/" + data.id + "/subroles/" + data.subrole_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  setDefaultOrganizationSubrole: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/organizations/" +
            data.id +
            "/subroles/" +
            data.subrole_id +
            "/default",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  toggleMandatoryOrganizationSubrole: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/organizations/" + data.id + "/subroles/mandatory", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getConfigOrganizationSubrole: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/" + data.id + "/subroles/config", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getAccessList: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/access", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  postAccessList: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/access/", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  replaceOrganizationSubrole: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/organizations/" +
            data.id +
            "/subroles/" +
            data.subrole_id +
            "/replace",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  restorePassOrganizationSubrole: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/organizations/" +
            data.id +
            "/subroles/" +
            data.subrole_id +
            "/password",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  orderOrganizationCourses: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/organizations/" + data.id + "/order-courses", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getAvailableFieldsImport: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/imports/fields", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  addOrganizationCourseProgramFromTo: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/organizations/" +
            data.id +
            "/courses/" +
            data.course_id +
            "/copy",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  toggleTaxonomyMandatory: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/organizations/" + data.id + "/taxonomies/mandatory", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getStatusInformation: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/enum/op-statuses", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getTaxonomyValues: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/" + data.id + "/taxonomies", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  createTaxonomyValue: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/organizations/" + data.id + "/taxonomies", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  editTaxonomyValue: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch(
          "admin/organizations/" + data.id + "/taxonomies/" + data.value_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  loginAsProviderSSO: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "admin/organizations/" +
            data.agency_id +
            "/providers/" +
            data.user_id +
            "/sso",
          {}
        )
        .then(res => {
          resolve(res);
          console.log(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  loginAsAdminSSO: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "admin/organizations/" +
            data.agency_id +
            "/users/" +
            data.user_id +
            "/sso",
          {}
        )
        .then(res => {
          resolve(res);
          console.log(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  loginSSO : function({ commit }, data){
    console.log("LOGINSSO");
    console.log("Data: ", data);
    
		return new Promise((resolve, reject) => {

			api.post('login-sso-user', data).then((res) => {
				
				console.log("Login SSO Response: ", res);
				if(res.data.auth){
					commit('setUserToken', res.data.access_token);
					commit('setIsLogged', res.data.auth);
					commit('setRole', res.data.user.view);
					commit('setPermissions', res.data.user.permissions);
					commit('setName', res.data.user.name);
					commit('setUser', res.data.user);
				}else{
					reject(res);
				}

				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});		
	},
  assignUserEmailCredentials: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/providers/" + data.id + "/assign-user", data.credentials)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteTaxonomyValue: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete(
          "admin/organizations/" + data.id + "/taxonomies/" + data.value_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getOrganizationLocation: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "admin/organizations/" + data.id + "/locations",
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
};

export default {
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/OrganizationModule.js